// extracted by mini-css-extract-plugin
export default {"home":"index_home__BB-za","content":"index_content__a0Fe4","top":"index_top__Nk06V","table":"index_table__CLKF+"};